<div mat-dialog-title class="dialog-info" closeOnEscape>
    <label class="dialogTitle">
        {{'SHIPPING_AND_HANDLING' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>

<div class="row" [formGroup]="shippingAndHandlingFormGroup">
    <div class="col-md-12">
        <mat-dialog-content class="contentPadding">
            <div class="table-container">
                <table mat-table [dataSource]="shippingDataSource" [trackBy]="trackByIndex">
                    <ng-container matColumnDef="shipping">
                        <th mat-header-cell *matHeaderCellDef> 
                            {{'SHIPPING_COLUMN' | translate}} 
                        </th>
                        <td mat-cell *matCellDef="let element" class="tableDefination"> 
                            {{element.shipping | translate}} 
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="dollars">
                        <th mat-header-cell *matHeaderCellDef> 
                            {{'DOLLARS' | translate}} 
                        </th>
                        <td mat-cell *matCellDef="let element" class="tableDefination right-align"> 
                            {{element.dollars | multilingualCurrency}} 
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="rate">
                        <th mat-header-cell *matHeaderCellDef> 
                            {{'RATE_COLUMN' | translate}} 
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index" class="tableDefination text-center">
                            <div [formGroupName]="getFormGroupName(i)">
                                <mat-form-field appearance="outline" class="form-field-size">
                                    <input matInput [appNumericMask]="rateConfig" inputmode="decimal" placeholder="Enter value" class="input-alignment form-input right-align" formControlName="rate">
                                </mat-form-field>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef> 
                            {{'TOTAL_COLUMN' | translate}} 
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index" class="tableDefination text-center"> 
                            <div [formGroupName]="getFormGroupName(i)">
                                <mat-form-field appearance="outline" class="form-field-size">
                                    <input matInput [appNumericMask]="sellPriceConfig" inputmode="decimal" placeholder="Enter value" class="input-alignment form-input right-align" formControlName="total">
                                </mat-form-field>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="rowHeight"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="rowHeight tableDefination"></tr>
                </table>
            </div>
            <div class="total-shipping-cost">
                <p class="label-TSC">
                    {{ 'TOTAL_SHIPPING_COST' | translate}}:
                </p>
                <p class="value-TSC">
                    {{totalShippingCost | multilingualCurrency}}
                </p>
            </div>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="actionsPadding">
            <button class="openCloseBtn" mat-raised-button color="primary">{{'NAVBAR_HELP' | translate}}</button>
            <button class="openCloseBtn" mat-raised-button color="primary" (click)="onSave()">{{'COMMON_DIALOGS_BTN_LABELS_OK' | translate}}</button>
            <button class="openCloseBtn" mat-raised-button color="warn" [mat-dialog-close]>{{'COMMON_DIALOGS_BTN_LABELS_CANCEL' | translate}}</button>
        </mat-dialog-actions>
    </div>
</div>